// import logo from './logo.svg';
import "./App.css";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import About from './components/About';
import { useState } from "react";
import Alert from "./components/Alert";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
function App() {

  const [mode,setMode] = useState('light');

  const [alert, setAlert] = useState(null);

  const showAlert = (t,m) =>{
    // console.log('Show alert called')
    setAlert({
      type: t,
      msg: m
    });

    setTimeout(() => {
      setAlert(null);
    }, 1500);

  }

  const modeSwitch = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor ='#002D62'
      } else{
        setMode('light');
        document.body.style.backgroundColor ='white'
    }
  }

  const router = createBrowserRouter([
    {
    path: "/",
    element: <>
      <Navbar title="TextTidy" aboutText="About" mode={mode} modeSwitch={modeSwitch} />
      <Alert alert={alert}/>
      <div className="container my-3" style={{backgroundColor: mode==='light'?'white':'#e2dcdc'}}>
        <TextForm heading="Insert Text to Get Started" mode={mode} showAlert={showAlert}/>
      </div>
      </>
    },
    {
      path: "/about",
      element: <>
        <Navbar title="TextTidy" aboutText="About" mode={mode} modeSwitch={modeSwitch} />
        <Alert alert={alert}/>
        <div className="container my-3" style={{backgroundColor: mode==='light'?'white':'#e2dcdc'}}>
          <About mode={mode} showAlert={showAlert}/>
        </div>
      </>
      }
  ]);

  return (
    <>
      {/* <Navbar title="TextTidy" aboutText="About TextTidy"/> */}
      {/* <Navbar title="TextTidy" aboutText="About" mode={mode} modeSwitch={modeSwitch} /> */}
      {/* <Alert alert={alert}/> */}
        
            {/* <div className="container my-3"> */}
              <RouterProvider router={router} />
            {/* </div> */}
        
        
    </>
  );
}

export default App;
